import React from "react";
import styled from "styled-components/macro";
import { mediaQueries } from "../styles/media.js";

const JunoQuestionDescription = styled.div`
  margin-bottom: 1rem;
  ${mediaQueries.md} {
    margin-bottom: 1.75rem;
  }
  max-width: 38rem;

  font-size: var(--juno-font-size-body-sm);

  p:first-child {
    margin-top: 0;
  }

  ul {
    display: block;
    color: var(--juno-color-text);
    font-family: var(--juno-font-family-body);
    font-weight: var(--juno-font-weight-light);
    font-size: var(--juno-font-size-body-sm);
    line-height: 1.5;
    margin-bottom: 1em;

    ${mediaQueries.md} {
      font-size: var(--juno-font-size-body-md);
      margin-bottom: 1.5em;
      line-height: 1.75;
    }

    padding-left: 24px;
    list-style-type: disc;

    li {
      margin-bottom: 2px;
      ${mediaQueries.md} {
        margin-bottom: 4px;
      }
    }
  }
`;

function QuestionDescription(props) {
  return <JunoQuestionDescription {...props}>{props.children}</JunoQuestionDescription>;
}

export default QuestionDescription;
